import { useMemo, useState } from 'react';
import { useOrchestratorList } from '../../hooks/useOrchestratorList';
import { getDuration } from '../../utils/dates';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';
import { CompletedChartTable } from '../CompletedChartTable/CompletedChartTable';

export const CompletedChart = () => {
  const { orchestrators } = useOrchestratorList();
  const [selectedNid, setSelectedNid] = useState<string | null>(null);

  const data = useMemo(() => {
    return (
      orchestrators.data
        ?.map(o => {
          if (!o.end_at) return null;
          const { days, hours, minutes } = getDuration(o.start_at, o.end_at);
          const total = days * 24 + hours + minutes / 60;
          return { nid: o.nid, hours: Math.round(total * 100) / 100 };
        })
        .filter(Boolean) ?? []
    );
  }, [orchestrators.data]);

  const handleBarClick = (data: any) => {
    if (data && data.nid) {
      if (selectedNid === data.nid) {
        setSelectedNid(null);
      } else {
        setSelectedNid(data.nid);
      }
    }
  };

  if (data.length === 0) return <div>No hay datos</div>;

  return (
    <div data-testid="completed-chart">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data as any}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="nid" />
          <YAxis />
          <Tooltip />
          <Bar
            dataKey="hours"
            fill="#8884d8"
            onClick={handleBarClick}
            style={{ cursor: 'pointer' }}
          />
        </BarChart>
      </ResponsiveContainer>
      <CompletedChartTable
        selectedNid={selectedNid}
        onResetSelection={() => setSelectedNid(null)}
      />
    </div>
  );
};
